var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close-account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core-/-Cross",
    transform: "translate(18.000000, 16.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14992358,2.80293311 C9.30925749,2.96226702 9.30925749,3.22059833 9.14992358,3.37993224 L6.55343268,5.97643268 L9.14992358,8.57292444 C9.30925749,8.73225835 9.30925749,8.99058967 9.14992358,9.14992358 C8.99058967,9.30925749 8.73225835,9.30925749 8.57292444,9.14992358 L5.97643268,6.55343268 L3.37993224,9.14992358 C3.22059833,9.30925749 2.96226702,9.30925749 2.80293311,9.14992358 C2.6435992,8.99058967 2.6435992,8.73225835 2.80293311,8.57292444 L5.39943268,5.97643268 L2.80293311,3.37993224 C2.6435992,3.22059833 2.6435992,2.96226702 2.80293311,2.80293311 C2.96226702,2.6435992 3.22059833,2.6435992 3.37993224,2.80293311 L5.97643268,5.39943268 L8.57292444,2.80293311 C8.73225835,2.6435992 8.99058967,2.6435992 9.14992358,2.80293311 Z",
    id: "Icon"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    cx: 24,
    cy: 22,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7759563,44 L15.2240437,44 C13.9957449,44 13,43.0483254 13,41.8743893 L13,6.1251398 C13,4.95120372 13.9957449,4 15.2240437,4 L32.7759563,4 C34.0042551,4 35,4.95120372 35,6.1251398 L35,41.8743893 C35,43.0483254 34.0042551,44 32.7759563,44 Z M13.0232554,8.55541821 L34.9769417,8.55541821 M26,40 C26,41.1048951 25.1048951,42 24,42 C22.8951049,42 22,41.1048951 22,40 C22,38.8957406 22.8951049,38 24,38 C25.1048951,38 26,38.8957406 26,40 Z M13.0232554,36 L34.9769417,36",
    id: "Icon",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseAccount);
export default __webpack_public_path__ + "static/media/icon-close-account.8c9a86d3.svg";
export { ForwardRef as ReactComponent };